import {Divider} from '@yandex-delivery/blocks'
import React from 'react'

import {BusinessOfferSlot} from '../BusinessOfferSlot/BusinessOfferSlot@mobile'
import {BusinessPlate} from '../BusinessPlate/BusinessPlate'
import type {SlotWidgetProps as Props} from '../types'
import {Slot} from './Slot'
import * as classes from './SlotWidget.classes'
import {isBusinessOfferMock, isBusinessPlate, isHeader, isRadio, isSummarization} from './utils'

export const SlotWidget: React.FC<Props> = props => {
  const {config} = props

  if (isRadio(config)) {
    return (
      <label>
        <Slot config={config} />
      </label>
    )
  }

  if (isHeader(config)) {
    return (
      <>
        <Slot config={config} />
        <Divider className={classes.divider} />
      </>
    )
  }

  if (isBusinessOfferMock(config)) {
    return <BusinessOfferSlot config={config} />
  }

  if (isBusinessPlate(config)) {
    return <BusinessPlate metricaLabel={config.metrica_label} name="is_business" />
  }

  if (isSummarization(config)) {
    return <Slot config={{...config, className: classes.summarization}} />
  }

  return <Slot config={config} />
}
